import _ from 'lodash';
import electron from 'app/native/node/electron';
import path from 'app/native/node/path';
import fs from 'app/native/node/fs';
import loadImage from 'app/utils/cornerstone/loadImage';

export default async function loadXRayAcquisitionDemoImages() {
  if (!(electron() && fs() && path())) return [];

  const builtInDemoAppImagesDir = path().join(
    electron().remote.app.getAppPath(),
    'build_electron_main/demo_xrays'
  );
  try {
    const filenames = await fs().promises.readdir(builtInDemoAppImagesDir, {
      recursive: true,
      withFileTypes: true,
    });
    console.debug('Found demo X-Ray images:', filenames);
    const demoImagesRecord = {};

    await Promise.all(
      filenames.map(async (fileEntry) => {
        try {
          if (!fileEntry.isFile()) return;
          const image = await loadImage({
            imageFile: {
              path: path().join(fileEntry.parentPath, fileEntry.name),
              isFromFileSystem: true,
            },
          });
          const { width, height, minPixelValue, maxPixelValue, windowCenter, windowWidth } =
            image.cornerstoneImage;
          const data = image.cornerstoneImage.getPixelData();

          const pathParts = path()
            .relative(builtInDemoAppImagesDir, fileEntry.parentPath)
            .split(path().sep);

          const imageData = {
            data,
            bytes_per_pixel: data.BYTES_PER_ELEMENT,
            width,
            height,
            minPixelValue,
            maxPixelValue,
            windowCenter,
            windowWidth,
          };
          _.times(pathParts.length, (index) => {
            let imagesArray = _.get(
              demoImagesRecord,
              [...pathParts.slice(0, index), 'images'],
              undefined
            );
            if (!imagesArray) {
              imagesArray = [];
              _.set(demoImagesRecord, [...pathParts.slice(0, index), 'images'], imagesArray);
            }

            imagesArray.push(imageData);
          });
        } catch {
          //
        }
        return undefined;
      })
    );

    return demoImagesRecord;
  } catch (error) {
    console.error('Error loading demo X-Ray images', error);
  }
  return [];
}
